import { EnvironmentProviders, Provider, Type, makeEnvironmentProviders } from '@angular/core';

import { LoggerConfig, defaultConfig } from './logger-config';
import { BaseMetadataService } from './metadata/base-metadata.service';
import { METADATA_TOKEN, MetadataService } from './metadata/metadata';
import { BaseServerLogger } from './server/base-server-logger.service';
import { SERVER_LOGGER_TOKEN, ServerLoggerInterface } from './server/server-logger.interface';

export const provideLogger = (
  config?: Partial<LoggerConfig>,
  serviceOverrides?: { customServerLogger?: Type<ServerLoggerInterface>; customMetadataService?: Type<MetadataService> }
): EnvironmentProviders => {
  const merged = { ...defaultConfig, ...config };

  const providers: Provider[] = [
    { provide: LoggerConfig, useValue: merged },
    {
      provide: SERVER_LOGGER_TOKEN,
      useClass: serviceOverrides?.customServerLogger ? serviceOverrides.customServerLogger : BaseServerLogger
    },
    {
      provide: METADATA_TOKEN,
      useClass: serviceOverrides?.customMetadataService ? serviceOverrides.customMetadataService : BaseMetadataService
    }
  ];

  return makeEnvironmentProviders(providers);
};
